import { useEffect, DependencyList } from 'react';

type Options = {
  /** Action invoked during handling key */
  keyboardAction: (e: KeyboardEvent) => void;
  /** Collection of handled keys */
  handledKeys: KeyboardEvent['code'][];
  /** Condition used to attach event listener to document */
  addEventListenerCondition: boolean;
  /** Dependency list for attaching event listener */
  eventListenerDependencies: DependencyList;
};

export const useKeypress = ({
  addEventListenerCondition,
  eventListenerDependencies,
  handledKeys,
  keyboardAction,
}: Options) => {
  const keyboardHandler = (e: KeyboardEvent) => {
    const keyCode = e.key;
    if (handledKeys.includes(keyCode)) keyboardAction(e);
  };

  useEffect(() => {
    if (addEventListenerCondition) {
      document.addEventListener('keydown', keyboardHandler);
    }
    return () => {
      document.removeEventListener('keydown', keyboardHandler);
    };
  }, [eventListenerDependencies]);
};
